import { createContext, useContext } from 'react';
import { Placement, PlacementStatus } from 'modules/placements/types';
import noop from 'utils/noop';

export type PlacementsManageContextState = {
  placements: Placement[];
  placementsLoading: boolean;
  selectedPlacement?: Placement;
  statusFilterTab: PlacementStatus;
  searchText: string;
  placementToArchive?: Placement;
  isArchiveModalOpen: boolean;
  isDisplayPriorityTakeoverOpen: boolean;
  displayPriorityTakeoverPlacementId?: number;

  setSelectedPlacement: (selected: Placement) => void;
  setStatusFilterTab: (status: PlacementStatus) => void;
  setSearchText: (searchValue: string) => void;
  openArchiveModal: (placementToArchive: Placement) => void;
  closeArchiveModal: () => void;
  setIsDisplayPriorityTakeoverOpen: (isOpen: boolean, placementId?: number | undefined) => void;
};

const defaultState: PlacementsManageContextState = {
  placements: [],
  placementsLoading: false,
  selectedPlacement: undefined,
  statusFilterTab: PlacementStatus.ACTIVE,
  searchText: '',
  placementToArchive: undefined,
  isArchiveModalOpen: false,
  isDisplayPriorityTakeoverOpen: false,
  displayPriorityTakeoverPlacementId: undefined,

  setSelectedPlacement: noop,
  setStatusFilterTab: noop,
  setSearchText: noop,
  openArchiveModal: noop,
  closeArchiveModal: noop,
  setIsDisplayPriorityTakeoverOpen: noop,
};

export const PlacementsManageContext = createContext<PlacementsManageContextState>(defaultState);

export const usePlacementsManageContext = () => useContext(PlacementsManageContext);
